import originFields from '../../defaults/PointOfOriginFields.json';

function viewIncidentDetails(triggerEvent, history) {
  const feature = triggerEvent.target.selectedFeature;
  if (feature && feature.attributes) {
    history.push(
      '/incidents/' + feature.attributes[originFields.idFields.incidents]
    );
  }
}

function viewResourceDetails(triggerEvent, history) {
  const feature = triggerEvent.target.selectedFeature;
  if (feature && feature.attributes) {
    history.push(
      '/resources/' + feature.attributes[originFields.idFields.resources]
    );
  }
}

export { viewIncidentDetails, viewResourceDetails };



// WEBPACK FOOTER //
// ./src/esri/widgets/popupActions.js